import { createContext } from 'react'

// used to store user sign in info (must also include in App.js)
export const UserContext = createContext(null)